import { put } from "redux-saga/effects";
import {
  verifyMemberEdc,
  verifyEdcDob,
  inquiryPayment,
  voidClaim,
} from "../../Services";
import axiosInstance from "../../Helper/axiosInterceptor";
import { URL_VERIFY_EDC_MEMBER } from "../../Config/Api";

export function* verifyEdcMemberSaga(action) {
  const payload = action.payload;
  try {
    const res = yield verifyMemberEdc(payload);

    yield put({ type: "REQ_VERIFY_MEMBER_EDC_SUCCEEDED", data: res.data });
  } catch (e) {
    yield put({ type: "REQ_VERIFY_MEMBER_EDC_FAILED", errData: e });
  }
}

export function* verifyEdcDobSaga(action) {
  const payload = action.payload;

  try {
    const res = yield verifyEdcDob(payload);
    yield put({ type: "REQ_VERIFY_MEMBER_EDC_DOB_SUCCEEDED", data: res.data });
  } catch (err) {
    yield put({ type: "REQ_VERIFY_MEMBER_EDC_DOB_FAILED", errData: err });
  }
}

export function* inquiryPaymentSaga(action) {
  const payload = action.payload;

  try {
    const res = yield inquiryPayment(payload);
    yield put({ type: "REQ_INQUIRY_PAYMENT_SUCCEEDED", data: res.data });
  } catch (err) {
    yield put({ type: "REQ_INQUIRY_PAYMENT_FAILED", errData: err });
  }
}

export function* voidClaimSaga(action) {
  const payload = action.payload;

  try {
    const res = yield voidClaim(payload);
    yield put({ type: "REQ_VOID_CLAIM_SUCCEEDED", data: res.data });
  } catch (err) {
    yield put({ type: "REQ_VOID_CLAIM_FAILED", errData: err });
  }
}
